export class ApplicationVersion {
  version: number;
}
